exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#fff",
	"menuActiveText": "#fff",
	"subMenuActiveText": "#fff",
	"menuBg": "#111744",
	"menuHover": "rgba(254,154,106,0.4)",
	"subMenuBg": "#1f2d3d",
	"subMenuHover": "#001528",
	"sideBarWidth": "144px",
	"headMenuText": "#fff",
	"headMenuActiveText": "#fff",
	"headMenuBg": "#111744"
};